import { AppService } from "../types";

type AppServiceKeys = "sdp" | "insight" | "lod";

export type Environment = Record<AppServiceKeys, string>;

export let environment: Environment = {
  sdp: "",
  insight: "",
  lod: "",
};

export const updateEnvironment = (newValue: Environment) => {
  environment = {
    ...environment,
    ...newValue,
  };
};

export const convertServicesToEnvironment = (services: AppService[]) => {
  return services.reduce<Record<string, string>>((result, service) => {
    result[service.key] = service.url;
    return result;
  }, {}) as Environment;
};
